<template>
  <div class="gov-shell">
    <div class="gov-tab-bar" v-if="tabs.length > 0">
      <div
        class="gov-tab"
        :class="{ active: activeTab === 'home' }"
        @click="activeTab = 'home'"
      >
        <span class="tab-title">经营决策智能体</span>
      </div>
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="gov-tab"
        :class="{ active: activeTab === tab.id }"
        @click="activeTab = tab.id"
      >
        <span class="tab-title">{{ tab.title }}</span>
        <i class="el-icon-close tab-close" @click.stop="closeTab(tab.id)"></i>
      </div>
    </div>

    <div v-show="activeTab === 'home'">
      <AgentLayout
        agentType="decision"
        title="经营决策智能体"
        description="基于多业务域数据，提供即时查询、深度分析与智能决策支持"
        placeholder="输入数据决策问题，按 Enter 发送..."
        @send="handleSend"
      >
        <!-- 快捷问题 -->
        <!-- <div class="quick-questions">
      <div class="question-item" v-for="(item, index) in quickQuestions" :key="index">
        <span class="q-icon" :style="{ background: item.iconBg, color: item.iconColor }">
          <i :class="item.icon"></i>
        </span>
        <span class="q-text">{{ item.text }}</span>
      </div>
    </div> -->

        <div class="open-tab-bar">
          <span
            v-for="item in tabItems"
            :key="item.id"
            class="open-tab-link"
            @click="handleOpenTab(item.id, item.title, item.url)"
            >{{ item.label }}</span
          >
        </div>

        <!-- 经营预警 -->
        <div
          class="section-card warning-card"
          @click="
            handleOpenTab(
              'decision-warning',
              '经营预警',
              '',
              'TargetDrawer',
              'warning',
            )
          "
        >
          <div class="section-header">
            <h3>
              经营预警
              <span class="badge badge-red"
                >🔔 {{ warnings.length }} 项待处理</span
              >
            </h3>
            <a
              href="javascript:;"
              class="section-link"
              @click.stop="
                handleOpenTab(
                  'decision-warning',
                  '经营预警',
                  '',
                  'TargetDrawer',
                  'warning',
                )
              "
              >查看全部 <i class="el-icon-arrow-right"></i
            ></a>
          </div>
          <div class="warning-grid">
            <div
              class="warn-box"
              v-for="w in warnings"
              :key="w.title"
              :class="'warn-' + w.level"
            >
              <span class="warn-icon" :class="'warn-icon-' + w.level">
                <i :class="w.icon"></i>
              </span>
              <div class="warn-body">
                <div class="warn-top">
                  <span class="warn-title">{{ w.title }}</span>
                  <span class="warn-badge" :class="'warn-badge-' + w.level">{{
                    w.level === "urgent" ? "紧急" : "关注"
                  }}</span>
                </div>
                <div class="warn-desc">{{ w.desc }}</div>
                <div class="warn-meta">{{ w.meta }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 报告模块：展示定时任务生成的报告卡片 -->
        <div
          class="section-card report-section"
          @click="
            handleOpenTab(
              'decision-cron-report',
              '报告',
              '',
              'CronReportDrawer',
            )
          "
        >
          <div class="section-header">
            <h3>
              报告 <span class="report-badge">AI 自主生成 · 每日自动更新</span>
            </h3>
            <div class="section-header-actions">
              <button
                v-if="firstPendingAnomalyReport"
                class="anomaly-top-btn"
                title="查看异常详情"
                @click.stop="openAnomalyDialog(firstPendingAnomalyReport)"
              >
                <i class="el-icon-warning-outline"></i> 异常详情
              </button>
              <a
                href="javascript:;"
                class="section-link"
                @click.stop="
                  handleOpenTab(
                    'decision-cron-report',
                    '报告',
                    '',
                    'CronReportDrawer',
                  )
                "
                >查看全部 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
          </div>
          <!-- 加载骨架 -->
          <div v-if="cronReportLoading" class="report-grid">
            <div class="report-skeleton" v-for="n in 3" :key="'skel-' + n">
              <span class="skel-line skel-short"></span>
              <span class="skel-line skel-long"></span>
              <span class="skel-line skel-mid"></span>
            </div>
          </div>
          <!-- 报告卡片列表 -->
          <div v-else-if="previewReports.length" class="report-grid">
            <CronReportCard
              v-for="item in previewReports"
              :key="item.id"
              :item="item"
              @click="
                handleOpenTab(
                  'decision-cron-report',
                  '报告',
                  '',
                  'CronReportDrawer',
                )
              "
              @anomaly-detail="openAnomalyDialog"
            />
          </div>
          <!-- 空状态 -->
          <div v-else class="report-empty">
            <i class="fa fa-file-text-o"></i> 暂无报告
          </div>
        </div>

        <!-- 核心目标 + 目标统计 -->
        <div class="content-row">
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>核心单</h3>
              <a
                href="javascript:;"
                class="section-link"
                @click="
                  handleOpenTab(
                    'decision-target-achieve',
                    '核心单',
                    '',
                    'TargetDrawer',
                    'target',
                    'achieve',
                  )
                "
                >查看全部 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
            <div class="kpi-list">
              <div class="kpi-item" v-for="item in kpiList" :key="item.id">
                <div class="kpi-header">
                  <span class="kpi-name">
                    {{ item.name }}
                    <span class="kpi-dept">{{ item.deptName }}</span>
                  </span>
                  <span class="kpi-status" :class="item.status">{{
                    item.statusLabel
                  }}</span>
                </div>
                <div class="kpi-bar-wrap">
                  <div
                    class="kpi-bar"
                    :style="{
                      width: item.progress + '%',
                      background: item.barColor,
                    }"
                  ></div>
                </div>
                <div class="kpi-footer" v-if="item.actualLabel">
                  <span>目标 {{ item.targetLabel }}</span>
                  <span>实际 {{ item.actualLabel }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section-card" style="flex: 0 0 340px">
            <div class="section-header">
              <h3>单统计</h3>
              <a
                href="javascript:;"
                class="section-link"
                @click="
                  handleOpenTab(
                    'decision-target-build',
                    '单统计',
                    '',
                    'TargetDrawer',
                    'target',
                    'build',
                  )
                "
                >查看全部 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
            <div class="stat-summary">
              <div
                class="stat-item"
                v-for="item in summaryStats"
                :key="item.label"
              >
                <span class="stat-num" :style="{ color: item.color }">{{
                  item.value
                }}</span>
                <span class="stat-label">{{ item.label }}</span>
              </div>
            </div>
            <div class="annual-progress">
              <div class="annual-header">
                <span>年度目标总进度</span>
                <span class="annual-rate"
                  >{{ annualRate }}% ({{ annualDone }}/{{ annualTotal }})</span
                >
              </div>
              <div class="annual-bar-wrap">
                <div
                  class="annual-bar"
                  :style="{ width: annualRate + '%' }"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 收入利润趋势 -->
        <div class="section-card">
          <div class="section-header">
            <h3>收入利润趋势</h3>
            <div class="trend-tags">
              <span class="trend-pill trend-down"
                ><i class="fa fa-arrow-down"></i> 收入 {{ revenueYoy }}%</span
              >
              <span class="trend-pill trend-up"
                ><i class="fa fa-arrow-up"></i> 利润 +{{ profitYoy }}%</span
              >
            </div>
          </div>
          <div class="chart-svg-wrap">
            <svg viewBox="0 0 600 120" class="trend-svg">
              <template v-for="(s, si) in trendSeries">
                <polyline
                  :key="'line-' + si"
                  fill="none"
                  :stroke="s.color"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :points="s.points"
                  :opacity="s.dashed ? 0.6 : 0.9"
                  :stroke-dasharray="s.dashed ? '4,4' : ''"
                />
                <g v-if="!s.dashed" :key="'dots-' + si" :fill="s.color">
                  <circle
                    v-for="(pt, pi) in s.dots"
                    :key="pi"
                    :cx="pt[0]"
                    :cy="pt[1]"
                    r="3.5"
                  />
                </g>
              </template>
            </svg>
          </div>
          <div class="chart-labels">
            <span v-for="(m, i) in monthLabels" :key="i">{{ m }}</span>
          </div>
          <div class="chart-legend">
            <span v-for="(s, i) in trendSeries" :key="'lg-' + i">
              <span
                class="legend-dot"
                :style="{
                  background: s.dashed ? 'transparent' : s.color,
                  border: s.dashed ? '1px dashed #94a3b8' : 'none',
                }"
              ></span
              >{{ s.label }}
            </span>
            <span class="legend-sum"
              >累计收入 <b>{{ cumulativeRevenue }}万</b></span
            >
            <span class="legend-sum"
              >累计利润
              <b style="color: #52c41a">{{ cumulativeProfit }}万</b></span
            >
          </div>
        </div>

        <!-- 两列布局：根因分析 + KPI -->
        <div class="content-row">
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>收入结构根因分析</h3>
              <span class="kg-badge"
                ><i class="el-icon-share"></i> 知识图谱</span
              >
            </div>
            <div class="kg-svg-wrap">
              <svg viewBox="0 0 700 200" class="kg-svg">
                <!-- 左侧：收入构成 -->
                <template v-for="(n, i) in rcRevNodes">
                  <g :key="'rv-' + i">
                    <rect
                      :x="18"
                      :y="n.y"
                      width="130"
                      height="40"
                      rx="10"
                      :fill="n.fill"
                      :stroke="n.stroke"
                      stroke-width="2"
                    />
                    <text
                      :x="83"
                      :y="n.y + 16"
                      text-anchor="middle"
                      fill="#1e293b"
                      font-size="12"
                      font-weight="600"
                      font-family="inherit"
                    >
                      {{ n.name }}
                    </text>
                    <text
                      :x="83"
                      :y="n.y + 33"
                      text-anchor="middle"
                      :fill="n.stroke"
                      font-size="14"
                      font-weight="700"
                      font-family="inherit"
                    >
                      {{ n.pct }}%
                    </text>
                  </g>
                  <path
                    :key="'rp-' + i"
                    :d="
                      'M148,' +
                      (n.y + 20) +
                      ' L210,' +
                      (n.y + 20) +
                      ' L230,' +
                      (n.y + 20)
                    "
                    fill="none"
                    stroke="#94a3b8"
                    stroke-width="1.5"
                    marker-end="url(#ag)"
                  />
                </template>

                <!-- 中间：营收缺口 -->
                <ellipse
                  cx="350"
                  cy="100"
                  rx="72"
                  ry="26"
                  fill="#fef2f2"
                  stroke="#ef4444"
                  stroke-width="3"
                />
                <text
                  x="350"
                  y="96"
                  text-anchor="middle"
                  fill="#991b1b"
                  font-size="14"
                  font-weight="700"
                  font-family="inherit"
                >
                  {{ rcGap.label }}
                </text>
                <text
                  x="350"
                  y="114"
                  text-anchor="middle"
                  fill="#dc2626"
                  font-size="12"
                  font-weight="600"
                  font-family="inherit"
                >
                  {{ rcGap.pct }}%
                </text>

                <!-- 右侧：根因 -->
                <template v-for="(c, i) in rcCauseNodes">
                  <g :key="'cb-' + i">
                    <rect
                      x="520"
                      :y="c.y"
                      width="150"
                      height="36"
                      rx="8"
                      :fill="c.fill"
                      :stroke="c.stroke"
                      stroke-width="1.5"
                      stroke-dasharray="4,2"
                    />
                    <text
                      x="595"
                      :y="c.y + 22"
                      text-anchor="middle"
                      :fill="c.textFill"
                      font-size="12"
                      font-weight="600"
                      font-family="inherit"
                    >
                      {{ c.label }}
                    </text>
                  </g>
                  <path
                    :key="'cp-' + i"
                    :d="'M475,' + (c.y + 18) + ' L518,' + (c.y + 18)"
                    fill="none"
                    :stroke="c.stroke"
                    stroke-width="1.2"
                    stroke-dasharray="3,2"
                    :marker-end="'url(#' + c.marker + ')'"
                  />
                </template>

                <defs>
                  <marker
                    id="ag"
                    viewBox="0 0 10 10"
                    refX="10"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto"
                  >
                    <path d="M0,0 L10,5 L0,10" fill="#94a3b8" />
                  </marker>
                  <marker
                    id="ao"
                    viewBox="0 0 10 10"
                    refX="10"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto"
                  >
                    <path d="M0,0 L10,5 L0,10" fill="#f97316" />
                  </marker>
                  <marker
                    id="ar"
                    viewBox="0 0 10 10"
                    refX="10"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto"
                  >
                    <path d="M0,0 L10,5 L0,10" fill="#ef4444" />
                  </marker>
                  <marker
                    id="ag2"
                    viewBox="0 0 10 10"
                    refX="10"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto"
                  >
                    <path d="M0,0 L10,5 L0,10" fill="#52c41a" />
                  </marker>
                  <marker
                    id="ap"
                    viewBox="0 0 10 10"
                    refX="10"
                    refY="5"
                    markerWidth="6"
                    markerHeight="6"
                    orient="auto"
                  >
                    <path d="M0,0 L10,5 L0,10" fill="#8b5cf6" />
                  </marker>
                </defs>
              </svg>
            </div>
            <div class="kg-footer">
              <span
                ><span
                  class="legend-dot"
                  style="background: #94a3b8; width: 8px; height: 2px"
                ></span
                >构成关系</span
              >
              <span
                ><span
                  class="legend-dot"
                  style="
                    background: transparent;
                    border-top: 1px dashed #f97316;
                    height: 0;
                    width: 8px;
                  "
                ></span
                >根因追溯</span
              >
              <span class="kg-summary"
                >营收缺口 <b style="color: #ef4444">{{ rcGap.pct }}%</b> ·
                建议：{{ rcRecommendations }}</span
              >
            </div>
          </div>
          <div class="section-card" style="flex: 0 0 380px">
            <div class="section-header">
              <h3>KPI 关键指标</h3>
              <span class="kpi-compare-badge">本月同比</span>
            </div>
            <div class="kpi-card-grid">
              <div
                class="kpi-metric"
                v-for="k in computedKpiMetrics"
                :key="k.label"
              >
                <div class="kpi-metric-label">{{ k.label }}</div>
                <div class="kpi-metric-value">{{ k.value }}</div>
                <div class="kpi-metric-change" :class="k.changeDir">
                  <i
                    :class="
                      k.changeDir === 'up'
                        ? 'fa fa-arrow-up'
                        : 'fa fa-arrow-down'
                    "
                  ></i>
                  {{ k.change }} vs 上月
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 两列：部门目标进度 + 成本分析 -->
        <div class="content-row">
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>部门目标进度</h3>
              <span class="kpi-compare-badge">年度达成率</span>
            </div>
            <div class="dept-progress-list">
              <div
                class="dept-progress-item"
                v-for="d in deptProgress"
                :key="d.name"
              >
                <div class="dept-progress-header">
                  <span class="dept-name">{{ d.name }}</span>
                  <span class="dept-rate" :class="d.rateClass"
                    >{{ d.rate }}%</span
                  >
                </div>
                <div class="dept-bar-wrap">
                  <div
                    class="dept-bar"
                    :style="{ width: d.rate + '%', background: d.barColor }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>成本分析</h3>
              <span class="trend-pill trend-amber"
                ><i class="fa fa-arrow-up"></i> 成本上涨
                {{ computedCostChange }}%</span
              >
            </div>
            <div class="cost-list">
              <div
                class="cost-item"
                v-for="c in computedCostItems"
                :key="c.label"
              >
                <div class="cost-header">
                  <span class="cost-label">{{ c.label }}</span>
                  <span class="cost-value">{{ c.value }}</span>
                </div>
                <div class="cost-bar-wrap">
                  <div
                    class="cost-bar"
                    :style="{ width: c.percent + '%', background: c.color }"
                  ></div>
                </div>
              </div>
              <div class="cost-total">
                <span>总成本</span>
                <span class="cost-total-value">{{
                  rawCostData ? rawCostData.totalCost + "万" : "6,730万"
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 两列：质量指标 + 生产效率 -->
        <div class="content-row">
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>质量指标</h3>
              <span class="kpi-compare-badge">本月统计</span>
            </div>
            <div class="quality-grid">
              <div
                class="quality-metric"
                v-for="q in computedQualityMetrics"
                :key="q.label"
              >
                <div class="quality-value" :style="{ color: q.color }">
                  {{ q.value }}
                </div>
                <div class="quality-label">{{ q.label }}</div>
              </div>
            </div>
            <div class="quality-footer">
              <span v-for="f in computedQualityFooter" :key="f.label"
                >{{ f.label }} <b>{{ f.value }}</b></span
              >
            </div>
          </div>
          <div class="section-card flex-1">
            <div class="section-header">
              <h3>生产效率</h3>
              <span class="trend-pill trend-up"
                ><i class="fa fa-arrow-up"></i> +{{
                  computedEfficiencyChange
                }}%</span
              >
            </div>
            <div class="efficiency-grid">
              <div
                class="eff-item"
                v-for="e in computedEfficiencyItems"
                :key="e.label"
              >
                <div class="eff-header">
                  <span class="eff-label">{{ e.label }}</span>
                  <span class="eff-value" :style="{ color: e.barColor }">{{
                    e.value
                  }}</span>
                </div>
                <div class="eff-bar-wrap">
                  <div
                    class="eff-bar"
                    :style="{ width: e.percent + '%', background: e.barColor }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 两列：分析SKILLS + 分析方法论 -->
        <div class="content-row">
          <div class="section-card flex-1 skills-methodology-card">
            <div class="card-title-bar">
              <span class="card-title-icon"><i class="fa fa-bolt"></i></span>
              <div class="card-title-text">
                <h4>{{ skillAnalysisTitle }}</h4>
                <p>{{ skillAnalysisDesc }}</p>
              </div>
              <a
                href="javascript:;"
                class="section-link"
                @click="
                  handleOpenTab(
                    'decision-skills',
                    '技能',
                    '',
                    'TargetDrawer',
                    'skills',
                    'library',
                  )
                "
                >查看全部 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
            <div class="skills-list-compact">
              <div class="skill-row" v-for="sk in skillsList" :key="sk.name">
                <span class="skill-row-icon" :style="{ color: sk.color }"
                  ><i :class="sk.icon"></i
                ></span>
                <span class="skill-row-name">{{ sk.name }}</span>
                <span class="skill-row-desc">{{ sk.desc }}</span>
              </div>
            </div>
          </div>
          <div class="section-card flex-1 skills-methodology-card">
            <div class="card-title-bar">
              <span class="card-title-icon"
                ><i class="fa fa-lightbulb-o"></i
              ></span>
              <div class="card-title-text">
                <h4>分析方法论</h4>
                <p>六大业务域场景分析方法与问题暴露</p>
              </div>
              <a
                href="javascript:;"
                class="section-link"
                @click="
                  handleOpenTab(
                    'decision-methodology',
                    '分析方法论',
                    '',
                    'TargetDrawer',
                    'methodology',
                    'library',
                  )
                "
                >查看全部 <i class="el-icon-arrow-right"></i
              ></a>
            </div>
            <div class="skills-list-compact">
              <div class="skill-row" v-for="m in methodScenes" :key="m.name">
                <span class="skill-row-icon" :style="{ color: m.color }"
                  ><i :class="m.icon"></i
                ></span>
                <span class="skill-row-name">{{ m.name }}</span>
                <span class="skill-row-desc">{{ m.methods }} 方法</span>
              </div>
            </div>
          </div>
        </div>
      </AgentLayout>
    </div>

    <div
      v-for="tab in tabs"
      v-show="activeTab === tab.id"
      :key="tab.id"
      class="gov-iframe-wrap"
    >
      <TargetDrawer
        v-if="tab.component === 'TargetDrawer'"
        :mode="tab.mode"
        :initialTab="tab.initialTab"
        @close="() => {}"
        @iframe-load="onTargetIframeLoad"
      />
      <CronReportDrawer
        v-else-if="tab.component === 'CronReportDrawer'"
        :visible="true"
        @close="() => {}"
      />
      <iframe
        v-else
        :src="tab.url"
        frameborder="0"
        class="gov-iframe"
        @load="onIframeLoad($event, tab)"
      ></iframe>
    </div>

    <!-- 异常详情弹框 -->
    <AnomalyDetailDialog
      :visible.sync="anomalyDialogVisible"
      :report="anomalyDialogReport"
      @disposed="handleAnomalyDisposed"
    />
  </div>
</template>

<script>
import AgentLayout from './agentLayout.vue'
import TargetDrawer from './TargetDrawer.vue'
import CronReportCard from './CronReportCard.vue'
import CronReportDrawer from './CronReportDrawer.vue'
import AnomalyDetailDialog from './AnomalyDetailDialog.vue'
import {
  getCoreTargets,
  getStatistics,
  getDepartmentProgress,
  getIndBaseDataByNames
} from '@/api/framework/target-system'
import { getReportPageApi } from '@/api/agentAuth'
import { getToken } from '@/utils/auth'
// eslint-disable-next-line no-unused-vars
import { BIGDATA_PATHS } from './bigdataPath'

const IND_NAMES = [
  'RevenueAndProfitTrends',
  'RootCauseAnalysisOfRevenueStructure',
  'KeyKPIs',
  'CostAnalysis',
  'ProductionEfficiency',
  'QualityIndicator',
  'SkillAnalysis'
]

export default {
  name: 'DecisionAgentPage',
  components: { AgentLayout, TargetDrawer, CronReportCard, CronReportDrawer, AnomalyDetailDialog },
  data() {
    return {
      quickQuestions: [],
      warnings: [
        {
          level: 'urgent',
          icon: 'fa fa-clock-o',
          title: '库存周转预警',
          desc: '库存周转天数 42天，超目标40%',
          meta: '仓储部 · 已持续 2 个月'
        },
        {
          level: 'warn',
          icon: 'fa fa-dollar',
          title: '成本异常波动',
          desc: '原材料成本环比上涨 3.2%，超出预算',
          meta: '采购部 · 铜/聚乙烯价格走强'
        },
        {
          level: 'warn',
          icon: 'fa fa-truck',
          title: '交付延期风险',
          desc: '本月准时交付率 67%，低于目标98%',
          meta: '供应链部 · 产能不足导致'
        }
      ],
      kpiList: [],
      summaryStats: [
        { value: '0', label: '已达成', color: '#52c41a' },
        { value: '0', label: '进行中', color: '#FF9800' },
        { value: '0', label: '未达标', color: '#f56c6c' }
      ],
      annualRate: 0,
      annualDone: 0,
      annualTotal: 0,
      monthLabels: ['11月', '12月', '1月', '2月', '3月', '4月', '5月'],
      rawTrendData: null,
      rawRootCauseData: null,
      rawKpiData: null,
      rawCostData: null,
      rawEfficiencyData: null,
      rawQualityData: null,
      rawSkillAnalysisData: null,
      kpiMetrics: [
        {
          label: '营收达成率',
          value: '92.4%',
          change: '2.1%',
          changeDir: 'down'
        },
        { label: '净利润率', value: '18.6%', change: '0.8%', changeDir: 'up' },
        { label: '订单量', value: '1,286', change: '5.3%', changeDir: 'down' },
        { label: '客单价', value: '4.8万', change: '1.2%', changeDir: 'up' }
      ],
      deptProgress: [],
      costItems: [
        {
          label: '原材料成本',
          value: '4,280万',
          percent: 72,
          color: '#4a5ff3'
        },
        { label: '人工成本', value: '1,560万', percent: 45, color: '#52c41a' },
        { label: '制造费用', value: '890万', percent: 38, color: '#faad14' }
      ],
      qualityMetrics: [
        { value: '96.2%', label: '一次合格率', color: '#52c41a' },
        { value: '94.8%', label: '滚动直通率', color: '#4a5ff3' },
        { value: '2.1%', label: '不良率', color: '#FF9800' }
      ],
      qualityFooter: [
        { label: '客诉', value: '3件' },
        { label: '返工率', value: '1.8%' },
        { label: '质量成本', value: '126万' }
      ],
      efficiencyItems: [
        { label: 'OEE', value: '85.3%', percent: 85, barColor: '#52c41a' },
        {
          label: '产能利用率',
          value: '78.6%',
          percent: 79,
          barColor: '#4a5ff3'
        },
        {
          label: '平均换型时间',
          value: '38min',
          percent: 62,
          barColor: '#faad14'
        },
        {
          label: '计划达成率',
          value: '96.5%',
          percent: 97,
          barColor: '#52c41a'
        }
      ],
      skillsList: [],
      methodScenes: [
        {
          name: '生产场景',
          icon: 'fa fa-industry',
          color: '#4a5ff3',
          methods: 3
        },
        { name: '财务场景', icon: 'fa fa-money', color: '#52c41a', methods: 3 },
        {
          name: '运营场景',
          icon: 'fa fa-bar-chart',
          color: '#ff7d00',
          methods: 3
        },
        { name: '研发场景', icon: 'fa fa-flask', color: '#a855f7', methods: 3 },
        { name: '行政场景', icon: 'fa fa-users', color: '#06b6d4', methods: 3 },
        {
          name: '安全场景',
          icon: 'fa fa-shield',
          color: '#ef4444',
          methods: 3
        }
      ],
      activeTab: 'home',
      tabs: [],
      tabItems: [],
      /** 定时报告数据 */
      cronReportList: [],
      cronReportLoading: false,
      anomalyDialogVisible: false,
      anomalyDialogReport: null
    }
  },
  computed: {
    revenueYoy() {
      return this.rawTrendData ? this.rawTrendData.yoyChange.revenue : -7.8
    },
    profitYoy() {
      return this.rawTrendData ? this.rawTrendData.yoyChange.profit : 3.2
    },
    cumulativeRevenue() {
      return this.rawTrendData ? this.rawTrendData.cumulative.revenue : 6180
    },
    cumulativeProfit() {
      return this.rawTrendData ? this.rawTrendData.cumulative.profit : 1149
    },
    trendSeries() {
      const colors = ['#4a5ff3', '#52c41a', '#94a3b8']
      const raw = this.rawTrendData
        ? this.rawTrendData.series
        : [
          {
            label: '收入',
            x: this.monthLabels,
            y: [820, 780, 750, 800, 900, 1000, 1130]
          },
          {
            label: '利润',
            x: this.monthLabels,
            y: [130, 120, 110, 140, 170, 200, 279]
          },
          {
            label: '去年收入',
            x: this.monthLabels,
            y: [860, 830, 800, 850, 930, 1020, 1160]
          }
        ]
      const allY = raw.flatMap((s) => s.y)
      const minY = Math.min(...allY)
      const maxY = Math.max(...allY)
      const xMin = 20
      const xMax = 530
      const yMin = 105
      const yMax = 10
      const scale = (v) =>
        yMin - ((v - minY) / (maxY - minY || 1)) * (yMin - yMax)
      return raw.map((s, i) => {
        const pts = s.y.map((v, j) => [
          xMin + j * ((xMax - xMin) / (s.y.length - 1)),
          scale(v)
        ])
        return {
          label: s.label,
          color: colors[i] || '#94a3b8',
          dashed: i === 2,
          points: pts.map((p) => p.join(',')).join(' '),
          dots: pts
        }
      })
    },
    rcRevNodes() {
      const raw = this.rawRootCauseData
        ? this.rawRootCauseData.revenueStructure
        : [
          { name: '产品收入', percentage: 52 },
          { name: '服务收入', percentage: 26 },
          { name: '其他收入', percentage: 10 }
        ]
      const fills = ['#eef2ff', '#f0fdf4', '#fefce8']
      const strokes = ['#4a5ff3', '#52c41a', '#eab308']
      return raw.map((r, i) => ({
        name: r.name,
        pct: r.percentage,
        y: 16 + i * 56,
        fill: fills[i],
        stroke: strokes[i]
      }))
    },
    rcGap() {
      const raw = this.rawRootCauseData
        ? this.rawRootCauseData.revenueGap
        : { label: '营收缺口', percentage: 7 }
      return { label: raw.label, pct: raw.percentage }
    },
    rcCauseNodes() {
      const raw = this.rawRootCauseData
        ? this.rawRootCauseData.rootCauses
        : [
          { label: '市场竞争加剧' },
          { label: '原材料成本上涨', impact: 3.2 },
          { label: '订单量下降', impact: 5.3 },
          { label: '下游需求疲软' }
        ]
      const colors = [
        {
          fill: '#fff7ed',
          stroke: '#f97316',
          textFill: '#9a3412',
          marker: 'ao'
        },
        {
          fill: '#fef2f2',
          stroke: '#ef4444',
          textFill: '#991b1b',
          marker: 'ar'
        },
        {
          fill: '#f0fdf4',
          stroke: '#52c41a',
          textFill: '#166534',
          marker: 'ag2'
        },
        {
          fill: '#f5f3ff',
          stroke: '#8b5cf6',
          textFill: '#4c1d95',
          marker: 'ap'
        }
      ]
      return raw.map((c, i) => ({
        label: c.impact ? c.label + ' ' + c.impact + '%' : c.label,
        y: 6 + i * 48,
        fill: (colors[i] || colors[0]).fill,
        stroke: (colors[i] || colors[0]).stroke,
        textFill: (colors[i] || colors[0]).textFill,
        marker: (colors[i] || colors[0]).marker
      }))
    },
    rcRecommendations() {
      return this.rawRootCauseData
        ? this.rawRootCauseData.recommendations
        : '优化产品结构 + 控制成本 + 提升订单'
    },
    computedKpiMetrics() {
      if (!this.rawKpiData) return this.kpiMetrics
      const fmt = (v, u) => {
        if (u === '%') return v + '%'
        if (u === '万元') return v + '万'
        return v >= 1000
          ? (v / 1).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          : String(v)
      }
      return this.rawKpiData.indicators.map((k) => ({
        label: k.name,
        value: fmt(k.currentMonth, k.unit),
        change: Math.abs(k.change) + '%',
        changeDir: k.change < 0 ? 'down' : 'up'
      }))
    },
    computedCostItems() {
      if (!this.rawCostData) return this.costItems
      const total = this.rawCostData.totalCost || 1
      const palette = ['#4a5ff3', '#52c41a', '#faad14']
      return this.rawCostData.costBreakdown.map((c, i) => ({
        label: c.name,
        value: c.amount + '万',
        percent: Math.round((c.amount / total) * 100),
        color: palette[i] || '#4a5ff3'
      }))
    },
    computedCostChange() {
      return this.rawCostData ? this.rawCostData.costChange : 3.2
    },
    computedEfficiencyItems() {
      if (!this.rawEfficiencyData) return this.efficiencyItems
      const colorMap = {
        OEE: '#52c41a',
        产能利用率: '#4a5ff3',
        平均换型时间: '#faad14',
        计划达成率: '#52c41a'
      }
      return this.rawEfficiencyData.indicators.map((e) => ({
        label: e.name,
        value: e.value + e.unit,
        percent: e.unit === '%' ? e.value : Math.round((e.value / 60) * 100),
        barColor: colorMap[e.name] || '#4a5ff3'
      }))
    },
    computedEfficiencyChange() {
      return this.rawEfficiencyData
        ? this.rawEfficiencyData.overallChange
        : 2.5
    },
    computedQualityMetrics() {
      if (!this.rawQualityData) return this.qualityMetrics
      const colorMap = {
        一次合格率: '#52c41a',
        滚动直通率: '#4a5ff3',
        不良率: '#FF9800'
      }
      return this.rawQualityData.indicators.map((q) => ({
        value: q.value + q.unit,
        label: q.name,
        color: colorMap[q.name] || '#4a5ff3'
      }))
    },
    computedQualityFooter() {
      if (!this.rawQualityData) return this.qualityFooter
      return (this.rawQualityData.supplementary || []).map((s) => ({
        label: s.name,
        value: s.value + s.unit
      }))
    },
    /** 预览报告卡片：取最近3条报告 */
    previewReports() {
      return this.cronReportList.slice(0, 3)
    },
    /** 顶部"异常详情"按钮要打开的那条：hasAnomaly=true 且还没处置的第一条 */
    firstPendingAnomalyReport() {
      return this.cronReportList.find(
        (item) => item.hasAnomaly && !item.anomalyDispositionStatus
      ) || null
    },
    skillAnalysisTitle() {
      return this.rawSkillAnalysisData
        ? this.rawSkillAnalysisData.title
        : '分析 SKILLS'
    },
    skillAnalysisDesc() {
      return this.rawSkillAnalysisData
        ? this.rawSkillAnalysisData.description
        : '沉淀的数据分析技能，快速复用分析能力'
    },
    computedSkillsList() {
      if (!this.rawSkillAnalysisData || !this.rawSkillAnalysisData.skills) {
        return this.skillsList
      }
      const icons = [
        'fa fa-search',
        'fa fa-sitemap',
        'fa fa-line-chart',
        'fa fa-exchange',
        'fa fa-bullseye',
        'fa fa-pie-chart',
        'fa fa-bar-chart',
        'fa fa-circle-o'
      ]
      const colors = [
        '#4a5ff3',
        '#52c41a',
        '#ff7d00',
        '#a855f7',
        '#06b6d4',
        '#ef4444',
        '#6366f1',
        '#ec4899'
      ]
      return this.rawSkillAnalysisData.skills.map((sk, i) => ({
        name: sk.title,
        icon: icons[i] || 'fa fa-star',
        color: colors[i] || '#4a5ff3',
        desc: sk.brief
      }))
    }
  },
  created() {
    this.fetchDashboardData()
    this.fetchCronReports()
  },
  methods: {
    /** 打开异常详情弹框 */
    openAnomalyDialog(report) {
      this.anomalyDialogReport = report
      this.anomalyDialogVisible = true
    },
    /** 异常处置完成回调：刷新报告列表让角标状态更新 */
    handleAnomalyDisposed() {
      this.fetchCronReports()
    },
    handleSend(val) {},
    async fetchDashboardData() {
      try {
        const [coreRes, statRes, deptRes, indRes] = await Promise.all([
          getCoreTargets(),
          getStatistics(),
          getDepartmentProgress(),
          getIndBaseDataByNames(IND_NAMES)
        ])

        // 打印接口原始返回，方便确认结构
        console.log('[ind-base-data] 返回:', indRes)

        if (coreRes.code === 0) {
          this.kpiList = coreRes.data.map((t) => ({
            id: t.id,
            name: t.targetName,
            deptName: t.deptName || '',
            targetLabel: t.targetValue + (t.targetUnit || ''),
            actualLabel:
              t.actualValue != null
                ? t.actualValue + (t.targetUnit || '')
                : null,
            progress: Math.min(
              Math.max(Math.round(Number(t.annualRate)), 0),
              100
            ),
            status:
              t.status === 'ACHIEVED'
                ? 'done'
                : t.status === 'PROCESSING'
                  ? 'active'
                  : 'fail',
            statusLabel:
              t.status === 'ACHIEVED'
                ? '已达成'
                : t.status === 'PROCESSING'
                  ? '进行中'
                  : '未达标',
            barColor:
              t.status === 'ACHIEVED'
                ? '#52c41a'
                : t.status === 'PROCESSING'
                  ? '#4A5FF3'
                  : '#f56c6c'
          }))
        }

        if (statRes.code === 0) {
          const s = statRes.data
          this.summaryStats = [
            {
              value: String(s.achievedCount || 0),
              label: '已达成',
              color: '#52c41a'
            },
            {
              value: String(s.processingCount || 0),
              label: '进行中',
              color: '#FF9800'
            },
            {
              value: String(s.unqualifiedCount || 0),
              label: '未达标',
              color: '#f56c6c'
            }
          ]
          this.annualDone = s.achievedCount || 0
          this.annualTotal = s.departmentTotal || 0
          this.annualRate =
            s.departmentTotal > 0
              ? Math.round((s.achievedCount / s.departmentTotal) * 100)
              : 0
        }

        if (deptRes.code === 0) {
          this.deptProgress = deptRes.data.map((d) => ({
            name: d.deptName,
            rate: Math.round(Number(d.annualRate)),
            rateClass:
              d.status === 'ACHIEVED'
                ? 'rate-good'
                : d.status === 'PROCESSING'
                  ? 'rate-mid'
                  : 'rate-bad',
            barColor:
              d.status === 'ACHIEVED'
                ? 'linear-gradient(90deg,#4a5ff3,#52c41a)'
                : d.status === 'PROCESSING'
                  ? 'linear-gradient(90deg,#4a5ff3,#faad14)'
                  : 'linear-gradient(90deg,#4a5ff3,#ff4d4f)'
          }))
        }

        // 指标基础数据映射
        this.applyIndData(indRes)
      } catch (e) {
        console.error('获取看板数据失败:', e)
      }
    },
    applyIndData(res) {
      const list = Array.isArray(res.data) ? res.data : []
      if (!list.length) return
      const map = {}
      list.forEach((item) => {
        map[item.name] = item
      })

      if (map.RevenueAndProfitTrends) {
        this.rawTrendData = map.RevenueAndProfitTrends.remark
        if (this.rawTrendData.series.length) {
          this.monthLabels = this.rawTrendData.series[0].x
        }
      }
      if (map.RootCauseAnalysisOfRevenueStructure) {
        this.rawRootCauseData = map.RootCauseAnalysisOfRevenueStructure.remark
      }
      if (map.KeyKPIs) {
        this.rawKpiData = map.KeyKPIs.remark
      }
      if (map.CostAnalysis) {
        this.rawCostData = map.CostAnalysis.remark
      }
      if (map.ProductionEfficiency) {
        this.rawEfficiencyData = map.ProductionEfficiency.remark
      }
      if (map.QualityIndicator) {
        this.rawQualityData = map.QualityIndicator.remark
      }
      if (map.SkillAnalysis) {
        this.rawSkillAnalysisData = map.SkillAnalysis.remark
        this.skillsList = this.computedSkillsList
      }
    },
    /** 获取报告列表（用于首页预览卡片） */
    async fetchCronReports() {
      this.cronReportLoading = true
      try {
        const res = await getReportPageApi({ page: 1, size: 10 })
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          const data = res.data || {}
          this.cronReportList = data.records || []
        }
      } catch (e) {
        console.error('获取报告列表失败:', e)
      } finally {
        this.cronReportLoading = false
      }
    },
    sendTokenToIframe(iframe) {
      const token = getToken()
      if (!token) return
      iframe.contentWindow.postMessage(
        JSON.stringify({
          action: 'token_send',
          payload: {
            token,
            expireAt: Date.now()
          },
          timestamp: Date.now()
        }),
        '*'
      )
    },
    onIframeLoad(event, tab) {
      this.sendTokenToIframe(event.target)
    },
    onTargetIframeLoad(event) {
      this.sendTokenToIframe(event.target)
    },
    handleOpenTab(id, title, url, component, mode, initialTab) {
      const exists = this.tabs.find((t) => t.id === id)
      if (!exists) {
        this.tabs.push({
          id,
          title,
          url: url || '',
          component: component || null,
          mode: mode || '',
          initialTab: initialTab || 'library'
        })
      }
      this.activeTab = id
      this.$nextTick(() => {
        setTimeout(() => {
          const selector =
            component === 'TargetDrawer' ? '.target-iframe' : '.gov-iframe'
          const iframe = this.$el.querySelector(selector)
          if (iframe) this.sendTokenToIframe(iframe)
        }, 300)
      })
    },
    closeTab(id) {
      const idx = this.tabs.findIndex((t) => t.id === id)
      if (idx === -1) return
      this.tabs.splice(idx, 1)
      if (this.activeTab === id) {
        this.activeTab = this.tabs.length
          ? this.tabs[this.tabs.length - 1].id
          : 'home'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-questions {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  .question-item {
    background: #fff;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .q-icon {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      i {
        font-size: 18px;
      }
    }
    .q-text {
      font-size: 13px;
      color: #333;
      line-height: 1.4;
    }
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }
}

.section-card {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
  transition: all 0.2s;

  &.flex-1 {
    flex: 1;
    margin-bottom: 0;
  }

  &.warning-card {
    cursor: pointer;
    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #1a1a2e;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .badge {
      font-size: 13px;
      font-weight: 400;
    }
    .badge-red {
      color: #f5222d;
    }

    .section-link {
      font-size: 13px;
      color: #3370ff;
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: 2px;
      i {
        font-size: 12px;
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.warning-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  .warn-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    border-radius: 12px;
    padding: 14px;

    &.warn-urgent {
      background: #fff2f0;
      border: 1px solid #ffd4d2;
    }
    &.warn-warn {
      background: #fffbe6;
      border: 1px solid #ffe58f;
    }

    .warn-icon {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      flex-shrink: 0;
      i {
        font-size: 14px;
      }

      &.warn-icon-urgent {
        background: #ffe4e1;
        color: #f5222d;
      }
      &.warn-icon-warn {
        background: #fff3cd;
        color: #e6a23c;
      }
    }

    .warn-body {
      flex: 1;
      min-width: 0;

      .warn-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 4px;

        .warn-title {
          font-size: 13px;
          font-weight: 600;
          color: #333;
        }

        .warn-badge {
          font-size: 10px;
          font-weight: 500;
          padding: 1px 8px;
          border-radius: 999px;
          &.warn-badge-urgent {
            background: #ffe4e1;
            color: #f5222d;
          }
          &.warn-badge-warn {
            background: #fff3cd;
            color: #e6a23c;
          }
        }
      }

      .warn-desc {
        font-size: 11px;
        color: #888;
        line-height: 1.5;
        margin-bottom: 2px;
      }
      .warn-meta {
        font-size: 10px;
        color: #aaa;
      }
    }
  }
}

.content-row {
  width: 100%;
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-card {
    height: auto;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    margin-bottom: 0;

    > .section-header {
      flex-shrink: 0;
    }

    > .stat-summary {
      flex: 1;
    }

    > .kpi-card-grid {
      flex: 1;
    }
  }
}

.kpi-list {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .kpi-item {
    .kpi-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .kpi-name {
        font-size: 13px;
        color: #333;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .kpi-dept {
        font-size: 11px;
        color: #94a3b8;
        font-weight: 400;
      }
      .kpi-status {
        font-size: 11px;
        padding: 1px 8px;
        border-radius: 4px;
        &.done {
          background: #e8f5e9;
          color: #52c41a;
        }
        &.active {
          background: #e3f2fd;
          color: #3370ff;
        }
        &.fail {
          background: #fff2f0;
          color: #f5222d;
        }
      }
    }
    .kpi-bar-wrap {
      height: 8px;
      background: #f0f0f0;
      border-radius: 4px;
      overflow: hidden;
      .kpi-bar {
        height: 100%;
        border-radius: 4px;
        transition: width 0.6s ease;
      }
    }
    .kpi-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      font-size: 11px;
      color: #94a3b8;
    }
  }
}

.stat-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  .stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 12px;
    border-radius: 8px;
    background: #fafbff;
    .stat-num {
      font-size: 24px;
      font-weight: 700;
    }
    .stat-label {
      font-size: 12px;
      color: #999;
    }
  }
}

.annual-progress {
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #4a5ff3 100%);
  color: #fff;
  .annual-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 13px;
    .annual-rate {
      font-weight: 600;
    }
  }
  .annual-bar-wrap {
    height: 8px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    overflow: hidden;
    .annual-bar {
      height: 100%;
      background: #fff;
      border-radius: 4px;
      transition: width 0.6s ease;
    }
  }
}

// Revenue/Profit trend
.trend-tags {
  display: flex;
  align-items: center;
  gap: 12px;
}
.trend-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 999px;
  i {
    font-size: 10px;
  }
  &.trend-down {
    background: #fef2f2;
    color: #ef4444;
  }
  &.trend-up {
    background: #f0fdf4;
    color: #16a34a;
  }
  &.trend-amber {
    background: #fffbeb;
    color: #d97706;
  }
}

.chart-svg-wrap {
  height: 110px;
  .trend-svg {
    width: 100%;
    height: 100%;
  }
}

.chart-labels {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #bbb;
  margin-top: 2px;
  padding: 0 4px;
}

.chart-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
  font-size: 11px;
  color: #999;
  flex-wrap: wrap;

  .legend-dot {
    display: inline-block;
    width: 10px;
    height: 3px;
    border-radius: 2px;
    margin-right: 4px;
    vertical-align: middle;
  }

  .legend-sum {
    color: #888;
    b {
      color: #333;
    }
  }
}

// Knowledge graph
.kg-badge {
  font-size: 11px;
  color: #3370ff;
  background: #eef2ff;
  padding: 3px 10px;
  border-radius: 999px;
}

.kg-svg-wrap {
  height: 170px;
  .kg-svg {
    width: 100%;
    height: 100%;
  }
}

.kg-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
  font-size: 10px;
  color: #999;
  flex-wrap: wrap;

  .legend-dot {
    display: inline-block;
    width: 8px;
    height: 2px;
    border-radius: 1px;
    margin-right: 3px;
    vertical-align: middle;
  }
  .kg-summary {
    color: #888;
    margin-left: auto;
    b {
      font-weight: 600;
    }
  }
}

// KPI metrics
.kpi-compare-badge {
  font-size: 11px;
  color: #999;
}

.kpi-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.kpi-metric {
  background: #fafbff;
  border-radius: 10px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .kpi-metric-label {
    font-size: 11px;
    color: #999;
    margin-bottom: 4px;
  }
  .kpi-metric-value {
    font-size: 20px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 4px;
  }
  .kpi-metric-change {
    font-size: 11px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    i {
      font-size: 10px;
    }
    &.up {
      color: #16a34a;
    }
    &.down {
      color: #ef4444;
    }
  }
}

// Department progress
.dept-progress-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dept-progress-item {
  .dept-progress-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    .dept-name {
      font-size: 13px;
      color: #333;
    }
    .dept-rate {
      font-size: 13px;
      font-weight: 600;
      &.rate-good {
        color: #52c41a;
      }
      &.rate-mid {
        color: #ff9800;
      }
      &.rate-bad {
        color: #f5222d;
      }
    }
  }
  .dept-bar-wrap {
    height: 10px;
    background: #f0f0f0;
    border-radius: 6px;
    overflow: hidden;
    .dept-bar {
      height: 100%;
      border-radius: 6px;
      transition: width 0.6s;
    }
  }
}

// Cost analysis
.cost-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  .cost-item {
    .cost-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
      .cost-label {
        font-size: 13px;
        color: #333;
      }
      .cost-value {
        font-size: 13px;
        font-weight: 600;
        color: #1a1a2e;
      }
    }
    .cost-bar-wrap {
      height: 8px;
      background: #f0f0f0;
      border-radius: 4px;
      overflow: hidden;
      .cost-bar {
        height: 100%;
        border-radius: 4px;
        transition: width 0.6s;
      }
    }
  }
  .cost-total {
    display: flex;
    justify-content: space-between;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;
    font-size: 13px;
    color: #888;
    .cost-total-value {
      font-size: 15px;
      font-weight: 700;
      color: #1a1a2e;
    }
  }
}

// Quality
.quality-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 16px;
  .quality-metric {
    background: #fafbff;
    border-radius: 10px;
    padding: 14px;
    text-align: center;
    .quality-value {
      font-size: 20px;
      font-weight: 700;
    }
    .quality-label {
      font-size: 11px;
      color: #999;
      margin-top: 4px;
    }
  }
}

.quality-footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  b {
    color: #333;
    font-weight: 500;
  }
}

// Production efficiency
.efficiency-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  .eff-item {
    .eff-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6px;
      .eff-label {
        font-size: 12px;
        color: #666;
      }
      .eff-value {
        font-size: 13px;
        font-weight: 600;
      }
    }
    .eff-bar-wrap {
      height: 7px;
      background: #f0f0f0;
      border-radius: 4px;
      overflow: hidden;
      .eff-bar {
        height: 100%;
        border-radius: 4px;
        transition: width 0.6s;
      }
    }
  }
}

// Skills & Methodology cards
.skills-methodology-card {
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
}

.card-title-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  .card-title-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: linear-gradient(135deg, #667eea 0%, #4a5ff3 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    i {
      font-size: 20px;
      color: #fff;
    }
  }
  .card-title-text {
    flex: 1;
    h4 {
      font-size: 16px;
      font-weight: 600;
      color: #1a1a2e;
      margin: 0 0 2px;
    }
    p {
      font-size: 12px;
      color: #999;
      margin: 0;
    }
  }
  .section-link {
    font-size: 13px;
    color: #3370ff;
    text-decoration: none;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 2px;
    i {
      font-size: 12px;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}

.skills-list-compact {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  div + div {
    border-top: 1px solid #f5f5f5;
  }

  .skill-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    transition: background 0.2s;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
    }
    .skill-row-icon {
      font-size: 13px;
      width: 18px;
      text-align: center;
    }
    .skill-row-name {
      font-size: 13px;
      color: #333;
      min-width: 80px;
    }
    .skill-row-desc {
      font-size: 12px;
      color: #aaa;
      margin-left: auto;
    }
  }
}

/* ── 报告模块 ── */
.report-section {
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
}

.report-badge {
  font-size: 11px;
  font-weight: 400;
  color: #94a3b8;
  margin-left: 8px;
}

.report-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.report-skeleton {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .skel-line {
    height: 14px;
    border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skel-shimmer 1.5s infinite;

    &.skel-short {
      width: 50%;
    }
    &.skel-long {
      width: 90%;
    }
    &.skel-mid {
      width: 70%;
    }
  }
}

@keyframes skel-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.report-empty {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 13px;

  i {
    margin-right: 6px;
  }
}

.gov-shell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.gov-tab-bar {
  display: flex;
  gap: 4px;
  padding: 8px 20px;
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
  flex-shrink: 0;
}
.gov-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  line-height: 1;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #595959;
  flex-shrink: 0;
}
.gov-tab:hover {
  background: rgba(255, 255, 255, 0.8);
}
.gov-tab.active {
  background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}
.gov-tab.active .tab-title {
  color: #fff;
}
.gov-tab.active .tab-close {
  color: #fff;
}
.tab-title {
  font-size: 13px;
  color: #666;
  font-family: PingFangSC-Regular;
}
.tab-close {
  font-size: 12px;
  color: #999;
}
.gov-iframe-wrap {
  flex: 1;
  min-height: 0;
  padding: 12px;
}
.gov-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
.open-tab-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.open-tab-link {
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid rgba(74, 95, 243, 0.2);
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.06),
    rgba(45, 127, 249, 0.03)
  );
  color: #4a5ff3;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.open-tab-link:hover {
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.12),
    rgba(45, 127, 249, 0.08)
  );
  border-color: rgba(74, 95, 243, 0.4);
  transform: translateY(-1px);
}

// ── 报告区 header 右侧按钮组 ──
.section-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.anomaly-top-btn {
  padding: 4px 10px;
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #fee2e2;
    border-color: #ef4444;
  }

  i { font-size: 14px; }
}
</style>
